// Utilitaires pour la date hégirienne (calendrier islamique)
// Repose entièrement sur l'API native Intl (aucune dépendance externe).

/**
 * Renvoie la date hégirienne formatée en français.
 * Exemple : "15 chaabane 1447"
 * @param {Date} date - La date grégorienne à convertir (par défaut : aujourd'hui).
 * @returns {string} La date hégirienne formatée.
 */
export const getHijriDate = (date = new Date()) => {
    try {
        return new Intl.DateTimeFormat('fr-FR-u-ca-islamic', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }).format(date);
    } catch (err) {
        // Repli en cas de navigateur ne supportant pas le calendrier islamique.
        return '';
    }
};

/**
 * Renvoie les composantes de la date hégirienne séparément.
 * @param {Date} date - La date grégorienne à convertir (par défaut : aujourd'hui).
 * @returns {{ day: string, month: string, year: string }}
 */
export const getHijriParts = (date = new Date()) => {
    try {
        const parts = new Intl.DateTimeFormat('fr-FR-u-ca-islamic', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }).formatToParts(date);

        // On extrait chaque composante par son type.
        const find = (type) => parts.find((p) => p.type === type)?.value ?? '';

        return {
            day: find('day'),
            month: find('month'),
            year: find('year'),
        };
    } catch (err) {
        return { day: '', month: '', year: '' };
    }
};
